class Premise {
    constructor() {
        this.p_name = '';
        this.p_type = '';
    }

    getData(name, type) {
        this.p_name = name;
        this.p_type =  type;

    }
}
export default Premise;


// WEBPACK FOOTER //
// ./resources/js/core/Premise.js